
import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import TimesList from "./TimesList";
import { TimeItem } from "./types";

interface TimesManagementProps {
  times: TimeItem[];
  onAddTime: () => void;
  onUpdateTime: (id: string, field: string, value: string | boolean | number) => void;
  onDeleteTime: (id: string) => void;
}

const TimesManagement: React.FC<TimesManagementProps> = ({
  times,
  onAddTime,
  onUpdateTime,
  onDeleteTime
}) => {
  return (
    <Card className="p-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">זמנים</h3>
        <Button onClick={onAddTime}>הוסף זמן</Button>
      </div>
      
      <TimesList
        times={times}
        onUpdateTime={onUpdateTime}
        onDeleteTime={onDeleteTime}
      />
    </Card>
  );
};

export default TimesManagement;
